import { TDropItem } from 'src/types';

/**
 * As pert of XP-17106, updates to org subtypes (which is type of school) are made
 * newly added values and associated new labels are - schoolTypeCatholic, schoolTypeDefense, schoolTypeIndianAffairs
 * schoolTypePrivate value (existing value) is remapped to private no religious affiliation label(new label)
 * schoolTypeChurch (existing value) is remapped to private religious label(new label)
 * The above 2 remappings are done for backward compatibility with existing data
 * These labels no longer exist - Church school or other religious, Private
 */
export const schoolOptions: TDropItem[] = [
  { value: 'schoolTypePublic', label: 'Public' },
  { value: 'schoolTypePrivateRel', label: 'Private (religious)' },
  { value: 'schoolTypeCatholic', label: 'Catholic School' },
  { value: 'schoolTypePrivate', label: 'Private (no religious affiliation)' },
  { value: 'schoolTypeYouth', label: 'Correctional youth facility' },
  { value: 'schoolTypeCharter', label: 'Charter school' },
  { value: 'schoolTypeHome', label: 'Home School Association' },
  { value: 'schoolTypeOnline', label: 'Course delivery primary online' },
  { value: 'schoolTypeDefense', label: 'Department of Defense' },
  { value: 'schoolTypeIndianAffairs', label: 'Bureau of Indian Affairs' },
  { value: 'schoolTypeOther', label: 'Other' },
];

export enum SchoolTypes {
  HS = 'hs',
  MS = 'ms',
  OTHER = 'other',
}

export const schoolTypeOptions = [
  {
    value: SchoolTypes.HS,
    label: 'High School',
  },
  {
    value: SchoolTypes.MS,
    label: 'Middle School',
  },
  {
    value: SchoolTypes.OTHER,
    label: 'Other',
  },
];
